import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import RetailersMenu from '../../components/menus/RetailersMenu';

const findUserRetailerCart = (cartsData, userId, retailerId) => {
  const cartData = cartsData.find((cart) => cart.user_id === userId && cart.retailer_id === retailerId);
  return cartData ? Object.values(cartData.variants) : [];
};

function RetailerMenuContainer(props) {
  const { retailerName } = props;

  return <RetailersMenu key={retailerName} {...props} />;
}

const mapStateToProps = (state, ownProps) => {
  const {
    match: { params },
  } = ownProps;
  const {
    role: { user, retailer },
    cart: { cartsData },
  } = state;
  let { dropship, replenish, administration } = state.checkPermissions;
  let cartVariantsCount = 0;

  // if the current retailer doesn't match the url
  const retailerId = +params.retailerId;
  if (!retailer || retailerId !== retailer.id) {
    return {
      pathname: ownProps.location.pathname,
    };
  }

  if (user) {
    const variants = findUserRetailerCart(cartsData, user.id, retailerId);
    cartVariantsCount = variants.reduce((sum, quantity) => sum + quantity, 0);
  }

  if (user.is_super_admin) {
    dropship = true;
    replenish = true;
    administration = true;
  }

  return {
    dropship,
    replenish,
    administration,
    retailerId,
    retailerName: retailer.name,
    cartVariantsCount,
    pathname: ownProps.location.pathname,
  };
};

export default connect(mapStateToProps, null)(RetailerMenuContainer);

RetailerMenuContainer.defaultProps = {
  dropship: false,
  replenish: false,
  administration: false,
  retailerName: '',
};

RetailerMenuContainer.propTypes = {
  replenish: PropTypes.bool.isRequired,
  dropship: PropTypes.bool.isRequired,
  administration: PropTypes.bool.isRequired,
  retailerName: PropTypes.string.isRequired,
  retailerId: PropTypes.number,
  supplierId: PropTypes.number,
};
